<template>
  <div class='SelectLogo'>
    <div class="label">
      <div class="text-label">Logomarca (280px X 100px):</div>
      <div class="arrow">
        <arrow-icon @showSubLinks="newValue => sublink = newValue"/>
      </div>
    </div>
    <div class="button" :class="{ contbutton: sublink }">
      <input ref="in" v-show="false" type="file" @change="inFile"/>
      <button @click="$refs.in.click()">Selecione a logomarca</button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ArrowIcon from '../Icons/ArrowIcon'
export default {
  name: 'SelectLogo',
  components: { ArrowIcon },
  data () {
    return {
      sublink: false
    }
  },
  methods: {
    ...mapActions(['UpdateLogo']),
    inFile (e) {
      for (let key in e.target.files) {
        if (key !== 'length' && key !== 'item') {
          this.getBase64(e.target.files[key])
        }
      }
    },
    getBase64 (file) {
      let reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.UpdateLogo(reader.result)
        // console.log(reader.result)
      }
      reader.onerror = (error) => {
        console.log('Error: ', error)
      }
    }
  }
}
</script>

<style scoped>
.SelectLogo {
  border: thin solid #CCCCCC;
  border-radius: 5px;
}

.label {
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 16px;
  color: #648EEA;
  border-bottom: thin solid #CCCCCC;
  background-color: #EEEEEE;
}

.text-label {
  width: 90%;
}

button {
  border: thin solid #CCCCCC;
  width: 100%;
  padding: 2%;
  border-radius: 5px;
  cursor: pointer;
  background-color: #FFFFFF;
  margin-top: 5px;
  font-size: 18px;
  text-align: left;
}

.button {
  padding: 0%;
  max-height: 0px;
  overflow: hidden;
  transition: max-height 0.15s ease-out;
}

.contbutton {
  padding: 2.5%;
  max-height: 50px;
  transition: max-height 0.15s ease-out;
}

.text-label {
  padding: 2%;
}
</style>
